import { render, staticRenderFns } from "./UserLogoImage.vue?vue&type=template&id=15dbdc90&scoped=true"
import script from "./UserLogoImage.vue?vue&type=script&lang=js"
export * from "./UserLogoImage.vue?vue&type=script&lang=js"
import style0 from "./UserLogoImage.vue?vue&type=style&index=0&id=15dbdc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dbdc90",
  null
  
)

export default component.exports